import { EAccess, EAccessMethod } from "@app/access/access.model";
import { EvideTableColumn, EvideTableColumnComponent, EvideTableColumnType } from "../common/common.model";

export interface INotificationEventHttpResponse {
    id: number;
    referenceGuid: string;
    eventName: string;
    notificationTemplateId: number;
    notificationTemplateTypeCode: string;
    notificationTemplateTypeDescription: string;
    notificationEventResponseId: number;
    notificationEventRequestId: number;
}

export class NotificationEvent {
    constructor(
        public id: number,
        public referenceGuid: string,
        public eventName: string,
        public notificationTemplateId: number,
        public notificationTemplateType: string,
        public notificationEventResponseId: number,
        public notificationEventRequestId: number
    ) { }

    public static adapt(data: INotificationEventHttpResponse) {
        return new this(
            data.id,
            data.referenceGuid,
            data.eventName,
            data.notificationTemplateId,
            `${data.notificationTemplateTypeCode} - ${data.notificationTemplateTypeDescription}`,
            data.notificationEventResponseId,
            data.notificationEventRequestId
        );
    }

    public static createBlank() {
        return new this(0, '', '', 0, '', 0, 0);
    }
}

export const NotificationEventColumns: Readonly<EvideTableColumn[]> = [
    {
        key: 'referenceGuid',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Reference Guid',
        displayValue: true,
        required: true,
        required_error: 'Reference Guid is Required',
        sortable: true,
        pattern: '^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$'
    },
    {
        key: 'eventName',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Input,
        isFormField: true,
        isFormEditableField: true,
        title: 'Event Name',
        displayValue: true,
        required: true,
        required_error: 'Event Name is Required',
        sortable: true
    },
    {
        key: 'notificationTemplateId',
        type: EvideTableColumnType.Number,
        compType: EvideTableColumnComponent.Dropdown,
        isFormField: true,
        isFormEditableField: true,
        title: 'Notification Template',
        hideInList: true,
        required: true,
        placeholder: 'Please Select Notification Template',
        required_error: 'Notification Template is Required',
        sortable: true
    },
    {
        key: 'notificationTemplateType',
        type: EvideTableColumnType.String,
        title: 'Template',
        displayValue: true,
        sortable: true,
        isFormEditableField: false
    },
    {
        key: 'options',
        type: EvideTableColumnType.Options,
        matIcon: 'more_vert',
        title: 'Options',
        optionMenu: [
            {
                key: 'view_endpoint',
                type: EvideTableColumnType.Action,
                matIcon: 'fas fa-arrow-right',
                title: 'Endpoint',
                accessVisibility: {
                    controllerKey: EAccess.NotificationEventEndpoint,
                    methodKey: EAccessMethod.GetNotificationEventEndpoints
                }
            },
            {
                key: 'edit',
                type: EvideTableColumnType.Action,
                matIcon: 'fa fa-fw fa-pen',
                title: 'Edit',
                accessVisibility: {
                    controllerKey: EAccess.NotificationEvent,
                    methodKey: EAccessMethod.Put
                }
            },
            {
                key: 'delete',
                type: EvideTableColumnType.Action,
                matIcon: 'fa fa-fw fa-trash-alt',
                title: 'Delete',
                accessVisibility: {
                    controllerKey: EAccess.NotificationEvent,
                    methodKey: EAccessMethod.Delete
                }
            }
        ]
    }
];